import allowListMerkleProofJsonDev from './whitelistDev/round1.json'
import presaleListMerkleProofJsonDev from './whitelistDev/round2.json'

import allowListMerkleProofJsonProd from './whitelistProd/round1.json'
import presaleListMerkleProofJsonProd from './whitelistProd/round2.json'
import { SalePhase } from './misc'

type MerkleProofTable = {
  [walletAddress in string]: string[]
}
const allowListMerkleProofDev = allowListMerkleProofJsonDev as MerkleProofTable
const presaleListMerkleProofDev = presaleListMerkleProofJsonDev as MerkleProofTable

const allowListMerkleProofProd = allowListMerkleProofJsonProd as MerkleProofTable
const presaleListMerkleProofProd = presaleListMerkleProofJsonProd as MerkleProofTable

export const getGeneratedMerkleProof = (walletAddress: string, phase: SalePhase) => {
  const isProd = process.env.REACT_APP_RELEASE_STAGE === 'production'
  switch (phase) {
    case SalePhase.WHITELIST:
      return (
        (isProd
          ? allowListMerkleProofProd[walletAddress.toLowerCase()]
          : allowListMerkleProofDev[walletAddress.toLowerCase()]) || []
      )
    case SalePhase.PRESALE:
      return (
        (isProd
          ? presaleListMerkleProofProd[walletAddress.toLowerCase()]
          : presaleListMerkleProofDev[walletAddress.toLowerCase()]) || []
      )
    case SalePhase.PUBLIC:
    default:
      return []
  }
}
